import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { errorToastMessage } from "../../utils/toast";
import { Box, CircularProgress, Typography } from "@mui/material";
import { NoDataContainer } from "../Common/styles/table";
import http from "../../utils/http";
import { AxiosResponse } from "axios";
import { useAppDispatch } from "../../Redux/hooks";
import { setUserAuth } from "../../Redux/reducers/userSlice";

const MagicLink = ({ studyId, consentId, versionId, tokenId }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const body = { token: tokenId };
        const res: AxiosResponse = await http.post(
          `/participant/auth/verify-temp-token`,
          body
        );
        const token = res.data?.data?.accessToken?.accessToken;
        const refreshToken = res.data?.data?.accessToken?.refreshToken;
        const userId = res.data.data?.participant?.id;
        const firstName = res?.data?.data?.participant?.firstName || "";
        const lastName = res?.data?.data?.participant?.lastName || "";
        const studyId = res?.data?.data?.participant?.study?.id;
        const lang =
          res?.data?.data?.lang !== "en"
            ? res?.data?.data?.participant?.lang ?? ""
            : "";
        localStorage.setItem("role", "participant");
        localStorage.setItem("crohn-access-token", token);
        localStorage.setItem("crohn-refresh-token", refreshToken);
        localStorage.setItem("user-id", userId);
        localStorage.setItem("first-name", firstName);
        localStorage.setItem("last-name", lastName);
        localStorage.setItem("study-id", studyId);
        localStorage.setItem("lang", lang);

        dispatch(
          setUserAuth({ authenticated: true, role: "participant", userId })
        );

        navigate(
          `/sign/${consentId}?versionId=${versionId}&studyId=${studyId}`,
          { replace: true }
        );
      } catch (err) {
        setError("Something went Wrong");
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setLoading, setError, consentId, versionId, studyId]);

  return loading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CircularProgress size={25} />
    </Box>
  ) : error ? (
    <NoDataContainer sx={{ height: "100%" }}>
      <Typography variant="body1" color="gray">
        {error}
      </Typography>
    </NoDataContainer>
  ) : null;
};

export default MagicLink;
